import React from "react";
import classNames from "../utils/classNames";

const Input = ({
  id = "",
  name = "",
  className = "",
  type = "text",
  placeholder = "",
  value,
  onChange,
  labelText = "",
  hasErrors = false,
  appendText = "",
  ...rest
}) => {
  const baseWrapperStyles = classNames(
    "flex items-center border rounded-lg",
    !hasErrors &&
      "border-[#afb6b9] focus-within:border-transparent focus-within:ring-2 focus-within:ring-primary",
    hasErrors && !appendText && "border-transparent ring-2 ring-red-500",
    hasErrors && appendText && "border-transparent ring-2 ring-red-500"
  );

  const baseInputStyles = classNames(
    "w-full border-0 p-3 focus:ring-0 ring-inset placeholder-[#afb6b9] bg-transparent",
    appendText ? "rounded-l-lg" : "rounded-lg"
  );

  return (
    <div>
      {labelText && (
        <label
          htmlFor={id}
          className={`block text-md font-bold leading-[1.5] mb-1 ${
            hasErrors ? "text-red-500" : ""
          }`}
        >
          {labelText}
        </label>
      )}
      <div className={baseWrapperStyles}>
        <input
          id={id}
          name={name}
          className={`${baseInputStyles} ${className}`}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...rest}
        />
        {appendText && (
          <span className="text-md px-4 py-1 border-l border-[#afb6b9] select-none">
            {appendText}
          </span>
        )}
      </div>
    </div>
  );
};

export default Input;
